import React from "react";
import { Link as RouterLink } from "react-router-dom";
import MetaTags from "react-meta-tags";

import {
  Box,
  Button,
  Container,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Page from "../components/Page";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.light,
    minHeight: "100%",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(3),
    paddingTop: 80,
    paddingBottom: 80,
  },
  image: {
    maxWidth: "100%",
    width: 560,
    maxHeight: 300,
    height: "auto",
  },
}));

const Error404View = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root}>
      <MetaTags>
        <title>Co-Tracking | 404</title>
      </MetaTags>
      <Container maxWidth="lg">
        <Typography align="center" variant="h1" color="textPrimary">
          <Box fontWeight="fontWeightBold">404: Page Does Not Exist</Box>
        </Typography>
        <Typography align="center" variant="h6" color="textSecondary">
          There must have been an error in the link that you posted or you do
          not have access to this page.
        </Typography>
        <Box mt={6} display="flex" justifyContent="center">
          <img
            alt="Under development"
            className={classes.image}
            src="/static/images/undraw_page_not_found_su7k.svg"
          />
        </Box>
        <Box mt={6} display="flex" justifyContent="center">
          <Button
            color="primary"
            component={RouterLink}
            to="/"
            variant="outlined"
            size="large"
          >
            Back to home
          </Button>
        </Box>
      </Container>
    </Page>
  );
};

export default Error404View;
